module.exports = __webpack_public_path__ + "uarm-images/tinymce-pion_big.png";